<div class="d-block">
  <ValidationObserver v-slot="{ handleSubmit  }" ref="form">
    <form @submit.prevent>
      <div class="row">
        <div class="col-lg-3">
          <div id="data-accordion">
            <div class="card najiz-card-panel mb-3">
              <div class="card-header najiz-panel-header" id="data-headingOne">
                <h4 class="mb-0 py-3">
                  <b>
                    بيانات العقد
                  </b>
                </h4>
              </div>
              <div id="collapseOne" class="collapse show height-scroll" aria-labelledby="data-headingOne"
                data-parent="#data-accordion">
                <div class="card-body px-0 py-0">
                  <div v-for="(item,index) in ConditionsData" :class="getControlClass(item)">
                    <div v-if="!item.disabled" @click="onControlClicked(item)" class="p-2">
                      <component :is="item.componentName" v-model="item.newValue"
                        @controlDataChanged="controlDataChanged" :inputValue="item.newValue" :index="index"
                        :label="item.oldValue" :id="item.controlId" :isIqama="item.code.includes('iqama')"
                        :isConditionControl="true" :isGregorian="item.code.includes('gregorianDate')"
                        :length="item.length" :city="item.newValue" :selectedDate="item.newValue" :name="item.name">
                      </component>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-9">
          <div id="accordion">
            <div class="card najiz-card-panel mb-3">
              <div class="card-header najiz-panel-header" id="headingOne">
                <h4 class="mb-0 py-3">
                  <b>
                    مراجعة العقد
                  </b>
                </h4>
              </div>
              <div id="collapseOne" class="collapse show  height-scroll" aria-labelledby="headingOne"
                data-parent="#accordion">
                <div class="card-body">
                  <h5 class="text-center "> <u>{{templateModel.name}}</u></h5>
                  <h5 v-if="templateModel.introduction && templateModel.introduction!='<p><br></p>'">
                    <u> المقدمة</u>:
                  </h5>
                  <p v-if=" templateModel.introduction && templateModel.introduction!='<p><br></p>'" id="introduction"
                    v-html="templateModel.introduction"></p>
                  <h5 v-if="templateModel.preliminary && templateModel.preliminary!='<p><br></p>'"><u>
                      تمهيد</u>:</h5>
                  <p v-if="templateModel.preliminary && templateModel.preliminary!='<p><br></p>'" id="preliminary"
                    v-html="templateModel.preliminary"></p>
                  <div v-for="(clause,masterIndex) in templateModel.clauses">
                    <div class="mb-5 h-100">
                      <div class="pb-0">
                        <p><u><b> {{masterIndex | getIndexedClauseName}} :
                              {{clause.clauseName}}</b></u></p>
                        <ul>
                          <li v-for="(textItem,index) in clause.childClauses" :key="textItem.id">
                            <div class="w-100 ">
                              <p dir="rtl">
                                {{index+1 + ' - ' }}
                                <span :id="'clause_'+textItem.id" @change="clauseDataChanged(textItem)"
                                  v-html="textItem.labelText"></span>
                              </p>
                              <ul class="pr-7 pt-1">
                                <li v-for="(subTextItem,subIndex) in  textItem.childClauses" :key="subTextItem.id">
                                  <p>
                                    {{subIndex | getIndexedLetter }} -
                                    <span :id="'clause_'+textItem.id+'_'+subTextItem.id"
                                      @change="clauseDataChanged(textItem)" v-html="subTextItem.labelText"></span>
                                  </p>
                                </li>
                              </ul>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <hr class="footer-hr pt-0 mt-0" />
          <div class="d-flex ">
            <button type="button" class="btn btn-link text-danger ml-auto pr-0 text-decoration-none"
              @click="onCancel">إلغاء</button>
            <a class="btn btn-outline-primary mx-4 px-8" @click="previousStep">السابق</a>
            <button type="submit" class="btn button--greenFill px-8" @click="nextStep">التالي</button>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</div>